import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from '@/store/modules/app'
import { IAgencyState } from '@/store/modules/agency'
import { IAgencySettingsState } from '@/store/modules/agencySettings'
import { IAgencyDashboardState } from '@/store/modules/agencyDashboard'
import { IAgencyScheduleState } from '@/store/modules/agencySchedule'
import { ICompanyListState } from '@/store/modules/companyList'
import { ICompanyDetailsState } from '@/store/modules/companyDetails'
import { IInvoiceListState } from '@/store/modules/invoiceList'
import { IInvoiceDetailsState } from '@/store/modules/invoiceDetails'
import { IWorkerListState } from '@/store/modules/workerList'
import { IWorkerDetailsState } from '@/store/modules/workerDetails'
import { IWorkerAnonState } from '@/store/modules/workerAnon'
import { ILocationListState } from '@/store/modules/locationList'
import { ILocationDetailsState } from '@/store/modules/locationDetails'
import { IBookingWizardState } from '@/store/modules/bookingWizard'
import { IBookingDetailsState } from '@/store/modules/bookingDetails'
import { IBookingListState } from '@/store/modules/bookingList'
import { IJobListState } from '@/store/modules/jobList'
import { IJobDetailsState } from '@/store/modules/jobDetails'
import { IContactListState } from '@/store/modules/contactList'
import { IContactDetailsState } from '@/store/modules/contactDetails'
import { IContactAnonState } from '@/store/modules/contactAnon'
import { IMessagingState } from '@/store/modules/messaging'
import { IReportsState } from '@/store/modules/reports'
import { IComplianceState } from '@/store/modules/compliance'
import { ISysState } from '@/store/modules/sys'


Vue.use(Vuex)

export interface IRootState {
  app: IAppState;
  agency: IAgencyState;
  agencySettings: IAgencySettingsState;
  agencyDashboard: IAgencyDashboardState;
  agencySchedule: IAgencyScheduleState;
  companyList: ICompanyListState;
  companyDetails: ICompanyDetailsState;
  invoiceList: IInvoiceListState;
  invoiceDetails: IInvoiceDetailsState;
  contactDetails: IContactDetailsState;
  contactList: IContactListState;
  contactAnon: IContactAnonState;
  workerDetails: IWorkerDetailsState;
  workerList: IWorkerListState;
  workerAnon: IWorkerAnonState;
  locationDetails: ILocationDetailsState;
  locationList: ILocationListState;
  bookingWizard: IBookingWizardState;
  bookingList: IBookingListState;
  bookingDetails: IBookingDetailsState;
  jobList: IJobListState;
  jobDetails: IJobDetailsState;
  messaging: IMessagingState;
  reports: IReportsState;
  compliance: IComplianceState;
  sys: ISysState;
}

export default new Vuex.Store<IRootState>({})